import React from 'react'
import Box from '@material-ui/core/Box'
import truncate from 'lodash/truncate'

import { humanizeString } from '../../utils/stringMinipulation'
import { R } from '../../utils/currency'
import { CueCard, CueCardItem, CueCardTitle } from '../CueCard'
import { CardHeading, CardContent } from '../../components/layout/Card'
import { Tooltip } from '@components/Tooltip'

export const LiabilityCard = ({ liability, Footer, highlighted }) => {
  return (
    <CueCard
      highlighted={highlighted}
    >
      <LiabilityCardHeading liability={liability} />
      <CardContent>
        <LiabilityName liability={liability} />
        <LiabilityDetails liability={liability} />
      </CardContent>
      <Footer />
    </CueCard>
  )
}

const LiabilityDetails = ({ liability }) => {
  return (
    <>
      <CueCardItem
        name={`Current Value`}
        value={R(liability.value).format()}
      />
      <CueCardItem
        name={`Repayments (p/m)`}
        value={R(liability.monthly_repayment).format()}
      />
      {liability.interest_rate &&
        <CueCardItem
          name={`Interest Rate`}
          value={`${liability.interest_rate}%`}
        />
      }
    </>
  )
}

const LiabilityCardHeading = ({ liability }) =>
  <CardHeading>
    <Box
      display='flex'
      justifyContent='space-between'
      alignItems='center'
    >
      <h5>{humanizeString(liability.liability_type)}</h5>
    </Box>
  </CardHeading>

const LiabilityName = ({ liability }) =>
  <Tooltip title={liability.name}>
    <CueCardTitle><span>{truncate(liability.name, { length: 28 })}</span></CueCardTitle>
  </Tooltip>
